import { render, staticRenderFns } from "./DictionaryWordsNew.vue?vue&type=template&id=7a025664&"
import script from "./DictionaryWordsNew.vue?vue&type=script&lang=js&"
export * from "./DictionaryWordsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports